<template>
  <div class="activity-wrap">
    <app-header />
    <div class="auto">
      <div class="mod1">
        <img src="../../assets/images/activity/202403/title1.jpg" alt="">
        <div class="btn" @click="isPopOrder = true;popNavIndex = 0;saveOrder('116')">
          <span>只需<em>698</em>元，立即抢购></span>
          <strong>4.5折，历史最低</strong>
        </div>
        <p class="agreement" @click="viweProtocol()">已经阅读并同意<em>《使用软件产品许可协议 》 </em></p>
      </div>
      <div class="mod1">
        <img src="../../assets/images/activity/202403/title2.jpg" alt="">
        <div class="btn"  @click="isPopOrder = true;popNavIndex = 1;saveOrder('73')">
          <span>只需<em>1880</em>元，立即抢购></span>
          <strong class="spe">立省1546元</strong>
        </div>
        <p class="agreement" @click="viweProtocol()">已经阅读并同意<em>《使用软件产品许可协议 》 </em></p>
      </div>
      <div class="mod2">
        <img src="../../assets/images/activity/202403/title3.png" alt="">
        <p>大智慧「365」：包含超级Level2+六脉神剑+DDE决策+黄金坑2.0+九转交易+波段线+股东深度挖掘+四维战法+SV资金流+分时博弈+辉煌之星等十多项炒股实用特权功能。</p>
        <div class="nav-img">
          <span v-for="(nav, index) in navList1" :key="index" :class="{cur: navIndex1 === index}" @click="changeIndex1(index)">{{nav}}</span>
        </div>
        <div class="nav-con">
          <el-carousel height="900px" @change="getIndex1" ref="bannerCarousel1" :interval="5000" arrow="never" indicator-position="none">
            <el-carousel-item v-for="item in bannerList1" :key="item.imgSrc">
              <img :src="item.imgSrc" />
              <h3>{{item.title}}</h3>
              <div class="info" v-show="navIndex1 == 0">
                <p>如图：超级Level2成交明细上显示，【三只松鼠300783】<em class="font-red">午后13:20分出现连续多笔736手大买单</em>，如此规律性的大单，多为主力大资金扫货，随后股价稳步拉升，<em class="font-red">日内大涨超15%</em>。而免费用户的分时成交明细由于3秒才合并发送一条数据，看不出任何主力大资金动向。</p>
                <p>此外，相对于普通用户只能看到5档买卖盘，超级Level2用户可看千档买卖盘，主力在哪个价位隐藏有大笔挂单，一目了然。</p>
                <strong class="tips">注：仅作案例演示，不作为投资依据</strong>
              </div>
              <div class="info info2" v-show="navIndex1 == 1">
                <p>当股票从低位拉升过程中，六脉神剑指标<em class="font-red">出现6个红色箭头↑</em>(6指标多头共振)，此时可关注其波段机会。</p>
                <p>股价上涨过程中，六脉神剑始终<em class="font-red">保持4个或以上红色箭头↑</em>，表明市场整体依旧多头力量占优，可保持关注多头行情的持续性。</p>
                <p>当股价大幅上涨之后出现大阴线或者六脉神剑指标<em class="font-green">出现3个或以上的绿色箭头↓</em>，表明短线<em class="font-green">股价有回调风险，保持警惕</em>。</p>
                <strong class="tips">注：仅作案例演示，不作为投资依据</strong>
              </div>
              <div class="info" v-show="navIndex1 == 2">
                <p>如图：【招商银行600036】在底部出现“<em class="font-red">黄金坑信号</em>”后强势拉升，<em class="font-red">波段涨幅超36%</em>。几乎所有牛股启动之前，都要向下挖坑。因为挖坑之后能让该股的筹码更为干净，主力更容易发动行情，</p>
                <p>当个股出现“黄金坑”信号后，表明个股或将触底反弹，投资者可等坑填平了、夯实了后重点跟踪。</p>
                <strong class="tips">注：仅作案例演示，不作为投资依据</strong>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-show="navIndex1 ==1" class="tips">功能入口：「大智慧365」收费版用户在软件内打开任意个股K线，搜索“六脉神剑”或首字母“LMSJ”回车确认后，即可在幅图指标查看“六脉神剑”指标信号。</div>
        <div v-show="navIndex1 ==2" class="tips">功能入口：「大智慧365」收费版用户在软件内打开任意个股K线，搜索“黄金坑”或首字母“HJK”回车确认后，即可在幅图指标查看“黄金坑”指标信号。</div>
      </div>
      <div class="button" @click="isPopOrder = true;popNavIndex = 0 ;saveOrder('116')">
        <span>低至1.9元/天，立即抢购></span>
        <strong>立省867元</strong>
      </div>
      <p class="agreement" @click="viweProtocol()">已经阅读并同意<em>《使用软件产品许可协议 》 </em></p>
      <div class="mod2">
        <img src="../../assets/images/activity/202403/title4.png" alt="">
        <p>大智慧「专业版」：包含大智慧「365」全部功能+自设股票池+超赢实时监控+超赢思维+机构去哪儿+董秘爆料+热点狙击+主动资金+竞价洞察等高端炒股功能。</p>
        <div class="nav-img nav-img2">
          <span v-for="(nav, index) in navList2" :key="index" :class="{cur: navIndex2 === index}" @click="changeIndex2(index)">{{nav}}</span>
        </div>
        <div class="nav-con">
          <el-carousel height="960px" @change="getIndex2" ref="bannerCarousel2" :interval="5000" arrow="never" indicator-position="none">
            <el-carousel-item v-for="item in bannerList2" :key="item.imgSrc">
              <img :src="item.imgSrc" :class="{mt: navIndex2==0}"/>
              <h3>{{item.title}}</h3>
              <div class="info" v-show="navIndex2 == 0">
                <p>如图中所示，用户自定义了3大选股条件：“成交额前150”+“换手率前150”+“净流入额前300”，<em class="font-red">3个股票池交集形成了用户的独家选股策略池</em>，优中选优、提炼之后再提炼，告别盲目凭感觉选股。</p>
                <strong class="tips">注：仅作案例演示，不作为投资依据</strong>
              </div>
              <div class="info" v-show="navIndex2 == 1">
                <p>如图中所示：<br>
                7月24日，超赢实时监控提示【山东钢铁600022】有<em class="font-red">“超大户”低位大幅吸筹，次日股价拉升</em>；<br>
                7月26日，超赢实时监控显示<em class="font-red">“超大户”继续加仓，股价大幅上涨</em>；<br>
                8月1日，股价再度大幅上涨，刷新新高时，超赢实时监控却显示<em class="font-green">“超大户”资金在大幅减仓</em>（散户、中户在加仓），<em class="font-green">随后股价一路下行</em>。</p>
                <strong class="tips">注：仅作案例演示，不作为投资依据</strong>
              </div>
              <div class="info" v-show="navIndex2 == 2">
                <p>如图：利用超赢思维划线功能，连接【中广天择603721】“波段低点（4月2日低点）”与“波段高点（4月19日高点）”，形成超赢「两点预测」。<br>其中C1（15.59元）/C2（13.62元）/C3（12.27元）为三条支撑线，当：</p>
                <p class="spe">①股价下跌触及任一支撑线（C1/C2/C3）<br>
                ②且连续3天收盘价企稳在支撑线之上（或收盘价站上支撑线3%或以上），表明支撑有效，<em class="font-red">关注抄底机会</em>。</p>
                <p><em class="font-red2">【中广天择】4月20日出现有效支撑信号后，股价一路飙升，15个交易日大涨84%。</em></p>
                <strong class="tips">注：仅作案例演示，不作为投资依据</strong>
              </div>
              <div class="info" v-show="navIndex2 == 3">
                <p>如图：利用超赢思维划线功能，连接【中广天择603721】“波段低点（4月2日低点）”、“波段高点（4月19日高点）”、“回调低点（4月28日低点）”，当：</p>
                <p class="spe">①股价上涨突破左侧波段高点后（4月19日高点），触及任一压力线D1（23.93元）/D2（25.28元）/D3（27.24元）<br>
        ②且连续3天收盘价站不上压力线，表明股性较弱，<em class="font-green">警惕高位见顶风险</em>。</p>
                <p><em class="font-green">【中广天择】5月28日出现高位见顶信号后，股价震荡盘整几日后持续下跌。</em></p>
                <strong class="tips">注：仅作案例演示，不作为投资依据</strong>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-show="navIndex2 ==1" class="tips">功能入口：「大智慧365」收费版用户在软件内打开任意个股K线，搜索“六脉神剑”或首字母“LMSJ”回车确认后，即可在幅图指标查看“六脉神剑”指标信号。</div>
        <div v-show="navIndex2 ==2" class="tips">功能入口：「大智慧365」收费版用户在软件内打开任意个股K线，搜索“黄金坑”或首字母“HJK”回车确认后，即可在幅图指标查看“黄金坑”指标信号。</div>
      </div>
      <p class="pro-title">大智慧「专业版」 + 主力筹码追踪 + 异动查 + 黄金通道</p>
      <div class="button button2" @click="isPopOrder = true;popNavIndex = 1;saveOrder('73')">
        <span>暖春购物节狂欢价¥1880，限时抢购></span>
      </div>
      <p class="agreement" @click="viweProtocol()">已经阅读并同意<em>《使用软件产品许可协议 》 </em></p>
      <div class="mod2 mod3">
        <div class="nav-img">
          <span v-for="(nav, index) in navList3" :key="index" :class="{cur: navIndex3 === index}" @click="changeIndex3(index)">{{nav}}</span>
        </div>
        <div class="nav-con">
          <el-carousel height="850px" @change="getIndex3" ref="bannerCarousel3" :interval="5000" arrow="never" indicator-position="none">
            <el-carousel-item v-for="item in bannerList3" :key="item.imgSrc">
              <img :src="item.imgSrc"/>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="button button2" @click="isPopOrder = true;popNavIndex = 0;saveOrder('116')">
        <span>暖春购物节，低至4.5折 丨 立即抢购></span>
      </div>
      <p class="agreement" @click="viweProtocol()">已经阅读并同意<em>《使用软件产品许可协议 》 </em></p>
    </div>
    <div class="qr-code">
      <img src="../../assets/images/activity/202403/qr-code.jpg" alt="">
      <h3>扫码下载APP</h3>
      <p>主力筹码追踪、异动查、黄金通道均为大智慧手机版炒股功能,需下载APP后使用。大智慧APP内<em>搜索“FF888”</em>激活使用</p>
    </div>
    <p class="footer-tip">风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险。</p>
    <div class="pop-order" v-show="isPopOrder">
      <!-- <div class="pop-con" @click.stop="isPopOrder = true" > -->
        <div class="pop-con">
        <span class="pop-close" @click="closePop">x</span>
        <div class="pop-inner" v-show="popNavIndex === 0">
          <p class="user-name">大智慧账号：{{ this.userName }}</p>
          <div class="pop-nav">
            <img src="../../assets/images/activity/202403/pop-title3.jpg" alt="">
            <span @click="popNavIndex = 1;saveOrder('73')"></span>
          </div>
          <div class="pop-main">
            <div class="con-l">
              <dl>
                <dt>
                  <img src="../../assets/images/activity/202403/pop-title1.png" alt="">
                </dt>
                <dd>超级Level-2</dd>
                <dd>六脉神剑</dd>
                <dd>黄金坑</dd>
                <dd>DDE决策</dd>
                <dd>波段线</dd>
                <dd>九转交易</dd>
                <dd>SV资金流</dd>
                <dd>四维战法</dd>
              </dl>
              <p>等十多项专属特权</p>
            </div>
            <div class="con-r">
              <div class="product">
                <p>大智慧365 - 12个月</p>
                <strong><em>¥</em>698</strong>
                <i>原价¥998</i>
                <span class="tag">暖春购物节特惠</span>
              </div>
              <img src="../../assets/images/activity/202403/pop-img1.jpg" alt="">
              <div class="pay-info" v-show="!isPay116">
                <div class="code">
                    <div class="mode">
                      <span @click="changeMode(index,'116')" v-for="(item, index) in modeList" :class="{cur: modeIndex116 === index}">{{item}}</span>
                    </div>
                    <qriously :value="qrData116" :size="100" level="M"  v-show="qrData116"/>
                </div>
                <div class="pay-money">
                  <p v-if="this.orderInfo116.orderType == 1">同意并支付：<strong>¥<em></em>{{ this.orderInfo116.payMoney }}</strong><span>使用补差升级优惠,共减{{this.orderInfo116.subtract + 867}}元</span></p>
                  <p v-else>同意并支付：<strong>¥<em></em>698</strong><span>已减867元，仅1.9元/天</span></p>
                  <p class="agreement" @click="viweProtocol()">已经阅读并同意<em>《使用软件产品许可协议 》 </em></p>
                  <div class="invoice-text">发票信息：电子普通发票
                    <span v-if="this.invoiceTitleType == 1">个人</span>
                    <span v-else>单位</span>
                    信息技术服务<em @click="openInvoice">发票填开></em></div>
                </div>
              </div>
              <div class="pay-info pay-success" v-show="isPay116">
                <div class="app">
                  <img src="../../assets/images/activity/202403/zdh-app.png" alt="">
                </div>
                <div class="text">
                  <h3>
                    <img src="../../assets/images/activity/202403/icon-success.png" alt="">
                    支付成功
                  </h3>
                  <p>扫码下载大智慧APP领取福利</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pop-inner pop-inner2" v-show="popNavIndex === 1">
          <p class="user-name">大智慧账号：{{ this.userName }}</p>
          <div class="pop-nav">
            <img src="../../assets/images/activity/202403/pop-title4.jpg" alt="">
            <span @click="popNavIndex = 0;saveOrder('116')"></span>
          </div>
          <div class="pop-main">
            <div class="con-l">
              <dl>
                <dt>
                  <img src="../../assets/images/activity/202403/pop-title2.png" alt="">
                </dt>
                <dd>自设股票池</dd>
                <dd>超赢实时监控</dd>
                <dd>超赢思维</dd>
                <dd>热点狙击</dd>
                <dd>机构去哪儿</dd>
                <dd>董秘爆料</dd>
                <dd>主动资金</dd>
                <dd>竞价洞察</dd>
              </dl>
              <p>汇聚经典核心功能</p>
            </div>
            <div class="con-r">
              <div class="product">
                <p>大智慧专业版 - 12个月</p>
                <strong><em>¥</em>1880</strong>
                <i>原价¥2680</i>
                <span class="tag">暖春购物节特惠</span>
              </div>
              <img src="../../assets/images/activity/202403/pop-img2.jpg" alt="">
              <div class="pay-info" v-show="!isPay73">
                <div class="code">
                    <div class="mode">
                      <span @click="changeMode(index,'73')" v-for="(item, index) in modeList" :class="{cur: modeIndex73 === index}">{{item}}</span>
                    </div>
                    <qriously :value="qrData73" :size="100" level="M"  v-show="qrData73"/>
                </div>
                <div class="pay-money">
                  <p v-if ="this.orderInfo73.orderType == 1">同意并支付：<strong>¥<em></em>{{ this.orderInfo73.payMoney }}</strong><span>使用补差升级优惠,共减{{this.orderInfo73.subtract + 1546}}元</span></p>
                  <p v-else>同意并支付：<strong>¥<em></em>1880</strong><span>已减1546元</span></p>
                  <p class="agreement" @click="viweProtocol()">已经阅读并同意<em>《使用软件产品许可协议 》 </em></p>
                  <div class="invoice-text">发票信息：电子普通发票
                    <span v-if="this.invoiceTitleType == 1">个人</span>
                    <span v-else>单位</span>
                    信息技术服务<em @click="openInvoice">发票填开></em></div>
                </div>
              </div>
              <div class="pay-info pay-success" v-show="isPay73">
                <div class="app">
                  <img src="../../assets/images/activity/202403/zdh-app.png" alt="">
                </div>
                <div class="text">
                  <h3>
                    <img src="../../assets/images/activity/202403/icon-success.png" alt="">
                    支付成功
                  </h3>
                  <p>扫码下载大智慧APP领取福利</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 电子发票组件 -->
        <invoice @saveInvoiceTitleType="changeInvoiceTitleType" ref="invoice" />
      </div>
      <!-- 365 -->
      <div class="pop-please" v-show="isPopPlease1">
        <div class="buttons">
          <span @click="isPopPlease1 = false; isPopOrder = false">狠心离开</span>
          <span @click="isPopPlease1 = false">支付解锁</span>
        </div>
      </div>
      <!-- 专业版 -->
      <div class="pop-please pop-please2" v-show="isPopPlease2">
        <div class="buttons">
          <span @click="isPopPlease2 = false; isPopOrder = false">狠心离开</span>
          <span @click="isPopPlease2 = false">支付解锁</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
</script>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import { tr } from 'date-fns/locale';
import de from 'date-fns/esm/locale/de/index.js';
import Invoice from "@/components/invoice/Invoice.vue";
export default {
  components: {
    AppHeader,
    Invoice
  },
  data () {
    return {
      navIndex1: 0,
      navList1: ['超级Level2', '六脉神剑', '黄金坑2.0'],
      bannerList1: [
        {
          imgSrc: require('../../assets/images/activity/202403/img1-1.jpg'),
          title: '一眼看破主力资金扫货动作',
        },
        {
          imgSrc: require('../../assets/images/activity/202403/img1-2.gif'),
          title: '6大经典指标共振原理研发而成，六剑出鞘，股海擒牛！',
        },
        {
          imgSrc: require('../../assets/images/activity/202403/img1-3.gif'),
          title: '“黄金坑”中有黄金，捕捉底部反转契机',
        },
      ],
      navIndex2: 0,
      navList2: ['自设股票池', '超赢实时监控', '超赢两点预测', '超赢三点预测'],
      bannerList2: [
        {
          imgSrc: require('../../assets/images/activity/202403/img2-1.jpg'),
          title: '优中选优，告别盲目凭感觉选股',
        },
        {
          imgSrc: require('../../assets/images/activity/202403/img2-2.gif'),
          title: '“超大户”资金动向一目了然，拒绝高位接盘！',
        },
        {
          imgSrc: require('../../assets/images/activity/202403/img2-3.jpg'),
          title: '下跌找抄底机会',
        },
        {
          imgSrc: require('../../assets/images/activity/202403/img2-4.jpg'),
          title: '上涨找逃顶机会',
        },
      ],
      navIndex3: 0,
      navList3: ['主力筹码追踪', '异动查', '黄金通道'],
      bannerList3: [
        {
          imgSrc: require('../../assets/images/activity/202403/img3-1.jpg'),
        },
        {
          imgSrc: require('../../assets/images/activity/202403/img3-2.jpg'),
        },
        {
          imgSrc: require('../../assets/images/activity/202403/img3-3.jpg'),
        },
      ],
      isPopOrder: false, // 支付弹框
      isLogin: true, // 是否登录
      popNavIndex: 1,
      s: this.$route.query.s,
      userName: "",

      isPay116: false, // 是否付款,
      payMode116: 23, // 默认微信支付
      orderInfo116: {},
      orderId116: "",
      wechatPayQrCode116: "",
      aliPayQrCode116: "",
      qrData116: "",
      modeIndex116: 0, // 支付方式

      isPay73: false, // 是否付款,
      payMode73: 23, // 默认微信支付
      orderInfo73: {},
      orderId73: "",
      wechatPayQrCode73: "",
      aliPayQrCode73: "",
      qrData73: "",
      lock: false,
      isPopPlease1: false, //专业版挽留弹框
      isPopPlease2: false, //365挽留弹框
      modeIndex73: 0, // 支付方式
      modeList: ['微信支付','支付宝','其他方式'],
      invoiceTitleType: 1,
      lastInvoiceTitleType: 1,
      selectedOrderId: '',
    }
  },
  created() {
    this.userName = this.$storage.getUserName()
    if(!this.s){
      this.s = "";
    }
  },
  mounted() {
  },
  methods: {
    changeIndex1 (val) {
      this.navIndex1 = val
      this.$refs.bannerCarousel1.setActiveItem(val)
    },
    getIndex1(val) {
      this.navIndex1 = val
    },
    changeIndex2 (val) {
      this.navIndex2 = val
      this.$refs.bannerCarousel2.setActiveItem(val)
    },
    getIndex2(val) {
      this.navIndex2 = val
    },
    changeIndex3 (val) {
      this.navIndex3 = val
      this.$refs.bannerCarousel3.setActiveItem(val)
    },
    getIndex3(val) {
      this.navIndex3 = val
    },
    closePop() {
      if (this.isPay116 || this.isPay73) {
        if(this.isPay116){
          this.isPay116 = false;
          this.orderId116 = "";
        }else{
          this.isPay73 = false;
          this.orderId73 = "";
        }
        this.isPopOrder = false
      } else {
        if (this.popNavIndex === 0) {
          this.closePopGetOrderStatus(this.orderId116,'116')
        } else {
          this.closePopGetOrderStatus(this.orderId73,'73')
        }
      }
    },
    updatePaymentInvoiceTitleType(){
      this.$get("/order/updateInvoiceTitleType?orderId=" + this.selectedOrderId + "&invoiceTitleType=" + this.invoiceTitleType)
        .then(response => {
          if (response.code !== 0) {
            this.alert(response.msg)
          }
      })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
    closePopGetOrderStatus(val,val2){
      this.$get("/order/status?id=" + val)
        .then(response => {
          if (response.code === 0 && response.data == 1) {
            if(val2 == '116'){
              this.orderId116 = "";
              this.isPopPlease1 = false
            }
            if(val2 == '73'){
              this.orderId73 = "";
              this.isPopPlease2 = false
            }
            this.isPopOrder = false
          }else{
            if(val2 == '116'){
              this.isPopPlease1 = true
            }
            if(val2 == '73'){
              this.isPopPlease2 = true
            }
          }
      })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
    changeMode(i,val) {
      if (i !==2) {
        if(val == '116'){
          this.modeIndex116 = i;
          if(i==0){
            this.payMode116 = 23
          }
          if(i==1){
            this.payMode116 = 29
          }
          this.getQrCode(this.orderId116,this.payMode116,val)
        }
        if(val == '73'){
          this.modeIndex73 = i;
          if(i==0){
            this.payMode73 = 23
          }
          if(i==1){
            this.payMode73 = 29
          }
          this.getQrCode(this.orderId73,this.payMode73,val)
        }
      } else {
        // 跳转
        if(val == '116'){
          this.payMore(this.orderId116)
        }
        if(val == '73'){
          this.payMore(this.orderId73)
        }

      }
    },
    saveOrder(val){
      if(val == '116'){
        if(this.orderId116){
          this.selectedOrderId = this.orderId116
          return false;
        }
      }else if( val == '73'){
        if(this.orderId73){
          this.selectedOrderId = this.orderId73
          return false;
        }
      }else{
        this.$global.alert("非法请求");
      }
      var activityParam = {
        productId: val,
        monthCount: 12
      }
      this.$post("/order/activityBuying", activityParam)
            .then(response => {
              if (response.code === 0) {
                var orderId = response.data.id;
                this.selectedOrderId = orderId;
                this.lastInvoiceTitleType = response.data.invoiceTitleType;
                this.invoiceTitleType = response.data.invoiceTitleType;
                if(val == '116'){
                  this.orderInfo116 = response.data;
                  this.orderId116 = orderId;
                  this.getQrCode(orderId,this.payMode116,'116')
                }else if(val == '73'){
                  this.orderInfo73 = response.data;
                  this.orderId73 = orderId;
                  this.getQrCode(orderId,this.payMode73,'73')
                }
                this.getOrderStatusTimer(orderId,val)
              } else if (response.code === 203) {
                this.isPopOrder = false;
                this.$global.alert(response.msg);
              }else{
                var params = {
                  productId: val,
                  monthCount: 12,
                  orderType: 0,
                  convertMoney: 0,
                  invoiceTitleType: 1,
                  questionsId: "0",
                  buySource: this.s
                };
                this.$post("/order/save", params)
                  .then(response => {
                    if (response.code === 0) {
                      var orderId = response.data.id;
                      this.selectedOrderId = orderId
                      if(val == '116'){
                        this.orderInfo116 = response.data;
                        this.orderId116 = orderId;
                        this.getQrCode(orderId,this.payMode116,'116')
                      }else if(val == '73'){
                        this.orderInfo73 = response.data;
                        this.orderId73 = orderId;
                        this.getQrCode(orderId,this.payMode73,'73')
                      }
                      this.getOrderStatusTimer(orderId,val)
                    } else {
                      this.isPopOrder = false;
                      this.$global.alert(response.msg);
                    }
                  })
                  .catch(err => {
                    this.$global.alertError();
                  });
              }
            })
            .catch(err => {
              this.$global.alertError();
            });
    },
    getOrderStatusTimer(val,val2) {
      var count = 60;
      var timer = setInterval(() => {
        if (count <= 0) {
          clearInterval(timer);
        } else {
          count--;
          this.getOrderStatus(val,val2)
          if((val2 == '116' && (this.isPay116)||this.orderId116 == "") || (val2 == '73' && (this.isPay73 || this.orderId73 == ""))){
            clearInterval(timer)
          }
        }
      }, 15000);
    },
    getOrderStatus(val,val2) {
      if(val !== this.orderId116 && val !== this.orderId73){
        return;
      }
      this.$get("/order/status?id=" + val)
        .then(response => {
          if (response.code === 0 && response.data == 1) {
            if(val2 == '116'){
              this.isPay116 = true;
              this.orderId116 = "";
            }
            if(val2 == '73'){
              this.isPay73 = true;
              this.orderId73 = "";
            }
          }
      })
        .catch(err => {
          alert("网络异常，请稍后重试");
        });
    },
    getQrCode(val,val2,val3) {
      if (this.lock) {
        return false;
      }
      var params = {
        id: val,
        payMode: val2
      };
      if(val3 == '116'){
        if (this.payMode116 == 29 && this.aliPayQrCode116) {
          this.qrData116 = this.aliPayQrCode116;
          return false;
        }
        if (this.payMode116 == 23 && this.wechatPayQrCode116) {
          this.qrData116 = this.wechatPayQrCode116;
          return false;
        }
      }else if (val3 == '73'){
        if (this.payMode73 == 29 && this.aliPayQrCode73) {
          this.qrData73 = this.aliPayQrCode73;
          return false;
        }
        if (this.payMode73 == 23 && this.wechatPayQrCode73) {
          this.qrData73 = this.wechatPayQrCode73;
          return false;
        }
      }
      this.lock = true;
      this.$get("/pay/qrcode", params)
        .then(response => {
          if (response.code === 0) {
             var qrData = response.data;
            if(val3 == '116'){
              this.qrData116 = qrData;
              if (this.payMode116 == 29) {
                this.aliPayQrCode116 = qrData;
              }
              if (this.payMode116 == 23) {
                this.wechatPayQrCode116 = this.qrData;
              }
            }else if (val3 == '73'){
              this.qrData73 = qrData;
              if (this.payMode73 == 29) {
                this.aliPayQrCode73 = this.qrData;
              }
              if (this.payMode73 == 23) {
                this.wechatPayQrCode73 = this.qrData;
              }
            }
          }
          this.lock = false;
        })
        .catch(err => {
          if(val3 == '116'){
            this.qrData116 = "";
          }else if (val3 == '73'){
            this.qrData73 = "";
          }
          this.lock = false;
        });
    },
    viweProtocol(){
      var routerDate = this.$router.resolve({name: 'Protocol'})
      let href = routerDate.href
      window.open(href, "_blank")
    },
    payMore(orderId){
      if(orderId){
        var routerDate = this.$router.resolve({name: 'OrderPay', params:{orderId: orderId}})
        let href = routerDate.href
        window.location.href = href
      }
    },
    openInvoice() {
      //调用子组件发票抬头类型
      this.$refs.invoice.openInvoice();
    },
    changeInvoiceTitleType(invoiceTitleType) {
      //获取发票组件发票抬头类型
      this.invoiceTitleType = invoiceTitleType;
      if(this.invoiceTitleType !== this.lastInvoiceTitleType){
        this.lastInvoiceTitleType = this.invoiceTitleType;
        this.updatePaymentInvoiceTitleType()
      }
    },
  }
}
</script>
<style lang="scss" scoped>
div, p, span, a{
  box-sizing: border-box;
}
.activity-wrap{
  background: url(../../assets/images/activity/202403/bg1.jpg) no-repeat center 100px,
  url(../../assets/images/activity/202403/bg2.jpg) no-repeat center 600px,
  url(../../assets/images/activity/202403/bg3.jpg) no-repeat center 1100px #a40000;
  .auto{
    width: 1255px;
    margin: 0px auto 0px;
    position: relative;
    padding-top: 775px;
  }
  .qr-code{
    position: fixed;
    right: 0;
    top: 340px;
    background: #fff;
    width: 155px;
    padding: 10px;
    border-radius: 10px;
    z-index: 10;
    h3{
      font-size: 18px;
      color: #000;
      text-align: center;
      margin-bottom: 3px;
    }
    p{
      word-break: break-all;
      font-size: 14px;
      color: #3d3d3d;
      em{
        color: #b72a2a;
        font-weight: bold;
      }
    }
  }
  .mod1{
    background: #fff;
    border-radius: 20px;
    padding: 70px 0 30px;
    margin-bottom: 90px;
    img{
      display: block;
      margin: 0 auto;
    }
    p{
      text-align: center;
      font-size: 12px;
      color: #777;
      em{
        color: #1997ff;
      }
    }
    .btn{
      margin: 20px auto;
      width: 764px;
      height: 88px;
      position: relative;
      span{
        display: block;
        line-height: 88px;
        background: linear-gradient(to right, #b00511, #da3434);
        border-radius: 50px;
        color: #fff;
        font-size: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        animation: bigger 1s linear infinite;
        cursor: pointer;
        em{
          color: #fff23e;
          background: linear-gradient(to bottom, #fff7b7, #fff23e);
          background-clip: text;
          -webkit-background-clip: text;/*将设置的背景颜色限制在文字中*/
          -webkit-text-fill-color: transparent;/*给文字设置成透明*/
          font-size: 56px;
          font-weight: bold;
          line-height: 1;
        }
      }
      strong{
        font-size: 26px;
        color: #c21920;
        height: 60px;
        line-height: 60px;
        border-radius: 30px;
        padding: 0 20px;
        background: linear-gradient(to bottom, #fffee8, #fff212);
        display: block;
        position: absolute;
        right: -95px;
        top: -22px;
        &.spe{
          right: -50px;
        }
      }
    }
  }
  .mod2{
    padding: 55px 55px 40px;
    background: linear-gradient(to bottom, #fff874, #fff 240px);
    border-radius: 40px;
    position: relative;
    &:before{
      content: '';
      display: block;
      background: url(../../assets/images/activity/202403/tag2.png) no-repeat;
      width: 182px;
      height: 126px;
      position: absolute;
      top: 60px;
      right: 76px;
    }
    >p{
      color: #2d2d2d;
      font-size: 24px;
      padding: 20px 30px;
      border: 1px dashed #7a7a7a;
      border-radius: 25px;
      margin: 30px 0 66px;
      position: relative;
      &:before{
        content: '';
        display: block;
        width: 25px;
        height: 25px;
        border-top: 1px dashed #7a7a7a;
        border-left: 1px dashed #7a7a7a;
        transform: rotate(45deg);
        position: absolute;
        top: -14px;
        left: 75px;
        background: #fffcc9;
      }
    }
    .nav-img{
      display: flex;
      justify-content: space-between;
      span{
        width: 336px;
        height: 78px;
        text-align: center;
        line-height: 78px;
        background: #e9e9e9;
        color: #838383;
        font-size: 42px;
        font-weight: bold;
        border-radius: 40px;
        cursor: pointer;
        &.cur{
          background: #be040e;
          color: #fff65b;
          position: relative;
          &:before{
            @include triangle-up(13px, 20px, #e8e8e8);
            position: absolute;
            left: 50%;
            bottom: -38px;
          }
        }
      }
    }
    .nav-con{
      background: #e8e8e8;
      padding: 28px 0 0;
      border-radius: 30px;
      margin-top: 36px;
      img{
        display: block;
        margin: 0 auto;
        height: 550px;
        &.mt{
          margin: 80px auto 40px;
        }
      }
      h3{
        font-size: 30px;
        color: #303030;
        padding: 30px 0 12px;
        font-weight: bold;
        border-bottom: 1px solid #b5b5b5;
        margin: 0 33px 25px;
        position: relative;
        &:before{
          @include triangle-down(7px, 12px, #b5b5b5);
          position: absolute;
          left: 50%;
          bottom: -13px;
        }
      }
      .info{
        margin: 0 35px;
        font-size: 23px;
        color: #303030;
        padding-bottom: 45px;
        position: relative;
        // padding-top: 20px;
        p{
          line-height: 32px;
          text-align: justify;
          margin-bottom: 15px;
          .font-red{
            color: #ad1a1a;
          }
          .font-red2{
            color: #991919;
          }
          .font-green{
            color: #079400;
          }
          &.spe{
            color: #676767;
          }
        }
        .tips{
          font-size: 12px;
          color: #c1c1c1;
          font-weight: normal;
          text-align: right;
          display: block;
        }
      }
      .info2{
        padding-top: 0;
        p{
          position: relative;
          padding-left: 35px;
          margin-bottom: 5px;
          &:before{
            content: '';
            display: block;
            background: url(../../assets/images/activity/202403/icon.png) no-repeat;
            width: 26px;
            height: 27px;
            position: absolute;
            left: 0;
            top: 2px;
          }
        }
      }
    }
    .tips{
      font-size: 14px;
      color: #acacac;
      margin: 14px 0 0 40px;
    }
    .nav-img2{
      span{
        width: 272px;
        height: 67px;
        line-height: 67px;
        font-size: 36px;
      }
    }
  }
  .agreement{
    font-size: 12px;
    color: #fff;
    text-align: center;
    margin-bottom: 60px;
    em{
      color: #fff991;
    }
  }
  .button{
    width: 750px;
    height: 128px;
    margin: 66px auto 18px;
    position: relative;
    span{
      width: 100%;
      height: 128px;
      display: block;
      background: linear-gradient(to bottom, #fffffe, #fff77d);
      border-bottom: 6px solid #9b4e12;
      border-radius: 70px;
      line-height: 128px;
      text-align: center;
      font-size: 46px;
      color: #303030;
      font-weight: bold;
      animation: bigger 1s linear infinite;
      cursor: pointer;
    }
    strong{
      position: absolute;
      top: -22px;
      right: -50px;
      background: url(../../assets/images/activity/202403/tag1.png) no-repeat;
      width: 174px;
      height: 55px;
      font-size: 22px;
      color: #fff;
      line-height: 55px;
      padding-left: 20px;
    }
  }
  .button{
    width: 1000px;
  }
  .pro-title{
    text-align: center;
    font-size: 28px;
    color: #fff;
    margin-top: 40px;
    margin-bottom: -40px;
  }
  .mod3{
    background: #fff;
    &:before{
      display: none;
    }
    .nav-con{
      img{
        height: 823px;
      }
    }
  }
  .footer-tip{
    font-size: 12px;
    color: #fff;
    padding: 50px 0;
    text-align: center;
    background: #262626;
  }
  .pop-order{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.5);
    z-index: 20;
    .pop-con{
      background: url(../../assets/images/activity/202403/pop-bg.png) no-repeat #f3f7f9;
      width: 1058px;
      height: 716px;
      margin-top: -358px;
      padding-top: 77px;
      position: absolute;
      left: 50%;
      margin-left: -529px;
      top: 50%;
      border-radius: 20px;
      .pop-close{
        position: absolute;
        top: 0px;
        right: 0px;
        color: #d79938;
        font-size: 30px;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
      }
    }
    .user-name{
      color: #4d0819;
      font-size: 16px;
      position: absolute;
      left: 30px;
      top: 30px;
      font-weight: bold;
    }
    .pop-inner{
      .pop-nav{
        position: relative;
        img{
          display: block;
        }
        span{
          width: 51%;
          height: 54px;
          display: block;
          position: absolute;
          left: 50%;
          top: 12px;
          cursor: pointer;
        }
      }
    }
    .pop-inner2{
      .pop-nav{
        span{
          left: 0;
        }
      }
    }
    .pop-main{
      display: flex;
      padding: 10px 24px 0;
    }
    .con-l{
      padding-top: 12px;
      border-right: 1px solid #ededed;
      width: 180px;
      dl{
        dt{
          margin-bottom: 25px;
          img{
            display: block;
          }
        }
        dd{
          color: #a8aaab;
          font-size: 15px;
          background: url(../../assets/images/activity/202403/pop-checked.png) no-repeat left center;
          padding-left: 22px;
          margin-bottom: 32px;
        }
      }
      p{
        border: 1px solid #e5e5e5;
        color: #1a1d20;
        font-size: 14px;
        width: 150px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        border-radius: 10px;
      }
    }
    .con-r{
      padding: 24px 0 0 50px;
      .product{
        position: relative;
        width: 245px;
        height: 200px;
        background: #ffe6b4;
        padding-top: 34px;
        text-align: center;
        border-radius: 10px;
        margin-bottom: 15px;
        p{
          color: #4d0819;
          font-size: 20px;
        }
        strong{
          display: block;
          color: #4d0819;
          font-size: 48px;
          line-height: 1;
          margin: 20px 0 25px;
          em{
            font-size: 25px;
          }
        }
        i{
          display: block;
          font-size: 16px;
          color: #c67741;
          text-decoration: line-through;
        }
        .tag{
          font-size: 14px;
          color: #fff;
          background: linear-gradient(to right, #ff7a33, #ff157d);
          border-radius: 8px 0 8px 0;
          width: 105px;
          height: 24px;
          display: block;
          position: absolute;
          left: 0;
          line-height: 24px;
          top: -12px;
        }
      }
      >img{
        display: block;
      }
      .pay-info{
        margin-top: 15px;
        background: #fff;
        border-radius: 10px;
        width: 770px;
        height: 162px;
        padding: 25px 30px 0;
        display: flex;
        position: relative;
        .code{
          border: 1px solid #c8c8c8;
          border-radius: 2px;
          margin-right: 20px;
          flex: none;
          width: 213px;
          height: 104px;
          display: flex;
          .mode{
            width: 110px;
            span{
              font-size: 13px;
              color: #777;
              display: block;
              height: 34px;
              line-height: 34px;
              border-right: 1px solid #c8c8c8;
              background: url(../../assets/images/activity/202403/icon-wx.png) no-repeat 10px center #f0f0f0;
              padding-left: 34px;
              cursor: pointer;
              +span{
                border-top: 1px solid #c8c8c8;
              }
              &:nth-child(2) {
                background-image: url(../../assets/images/activity/202403/icon-zfb.png);
              }
              &:nth-child(3) {
                background-image: url(../../assets/images/activity/202403/icon-mode.png);
              }
              &.cur{
                background-color: #fff;
                border-right: 1px solid #fff;
              }
            }
          }
          img{
            display: block;
            width: 100px;
            height: 100px;
          }
        }
        .pay-money{
          margin-top: 25px;
          p{
            color: #777777;
            font-size: 16px;
            display: flex;
            align-items: center;
            strong{
              color: #ad7d54;
              font-size: 32px;
              margin: 0 20px 0 5px;
              em{
                font-size: 16px;
              }
            }
            span{
              font-size: 14px;
              color: #fff;
              background: linear-gradient(to right, #ff7a33, #ff157d);
              border-radius: 8px 0 8px 0;
              height: 24px;
              line-height: 24px;
              text-align: center;
              padding: 0 10px;
            }
          }
          .icon-zfb{
            background: url(../../assets/images/activity/202403/icon-zfb.png) no-repeat left center;
            padding-left: 50px;
            font-size: 13px;
            color: #c1c1c2;
            margin: 5px 0 10px;
          }
          .agreement{
            font-size: 12px;
            color: #777777;
            margin-bottom: 0;
            em{
              color: #1997ff;
            }
          }
          .invoice-text{
            font-size: 12px;
            color: #999;
            margin-top: 9px;
            span{
              margin: 0 12px;
            }
            em{
              color: #1997ff;
              margin-left: 12px;
              cursor: pointer;
            }
          }
        }
        .pay-more{
          position: absolute;
          font-size: 12px;
          color: #777777;
          background: url(../../assets/images/activity/202403/pop-more.jpg) no-repeat right center;
          padding-right: 15px;
          right: 40px;
          bottom: 35px;
          line-height: 1;
        }
      }
      .pay-success{
        .app{
          border: 1px solid #f1f1f1;
          padding: 2px;
          width: 110px;
          height: 110px;
          margin-right: 20px;
          img{
            display: block;
            width: 103px;
          }
        }
        .text{
          font-size: 16px;
          color: #777;
          margin-top: 25px;
          p{
            font-weight: bold;
          }
          h3{
            display: flex;
            color: #333;
            font-size: 22px;
            font-weight: bold;
            margin-bottom: 10px;
          }
        }
      }
    }
    .pop-please{
      background: url(../../assets/images/activity/202403/pop-bg2.png) no-repeat;
      padding: 230px 36px;
      width: 430px;
      height: 309px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-left: -215px;
      margin-top: -164px;
      z-index: 20;
      .buttons{
        display: flex;
        justify-content: space-between;
        span{
          font-size: 18px;
          color: #262626;
          width: 163px;
          height: 49px;
          text-align: center;
          line-height: 49px;
          background: #ebebeb;
          border-radius: 40px;
          cursor: pointer;
          &:nth-child(2) {
            color: #7c390f;
            background: linear-gradient(to right, #efb390, #fbdabe);
          }
        }
      }
    }
    .pop-please2{
      background: url(../../assets/images/activity/202403/pop-bg3.png) no-repeat;
    }
  }
}
 @keyframes bigger {
  0%{
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
  50%{
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  100%{
    -webkit-transform: scale(0.9);
            transform: scale(0.9);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/activity20240301.vue